module.exports = __webpack_public_path__ + "console/img/payments.5629353d.png";